<template>
  <VerticalModal
    :visible="visible"
    body-class=""
    width="2xl"
    @close="close"
    :header-title="
      'بارگیری شناسه بار ' +
      (loadDetail?.load_id || '') +
      ' - ' +
      (has_warehouse_transfer
        ? loadDetail?.load_type_title
        : get_fullname(loadDetail?.user) || '')
    "
  >
    <template #body>
      <div
        class="tw-w-full tw-grid tw-grid-cols-[400px_auto] tw-h-full tw-text-blue-dark-500"
      >
        <!--    Right Side    -->

        <div class="tw-border-l tw-border-blue-dark-50 tw-px-[44px] tw-py-6">
          <div
            class="tw-border tw-border-blue-dark-50 tw-rounded-[12px] tw-py-4 tw-px-3 tw-text-tiny"
          >
            <ul class="tw-mb-0">
              <li class="tw-flex tw-justify-between tw-pb-5">
                <div>
                  <BaseIcon
                    icon="tag"
                    size="24"
                    class="tw-align-middle tw-ml-3"
                  ></BaseIcon>
                  اطلاعات پایه
                </div>
                <div
                  class="tw-text-primary-500 tw-cursor-pointer tw-font-bold"
                  @click="openEditLoadModal = true"
                >
                  <BaseIcon
                    icon="edit-note"
                    size="24"
                    class="tw-align-middle tw-ml-2"
                  ></BaseIcon>
                  ویرایش
                </div>
              </li>

              <template v-if="getDataLoading">
                <li class="tw-flex tw-justify-between tw-items-end tw-mb-1">
                  <ShineLoading
                    width="40px"
                    height="40px"
                    size="lg"
                    body_height="40"
                    class-line="!tw-my-0"
                  />
                  <ShineLoading
                    width="100px"
                    size="lg"
                    body_height="30"
                    class-line="!tw-my-0"
                  />
                </li>
                <li v-for="i in 10" class="tw-py-1">
                  <ShineLoading
                    width="100"
                    size="lg"
                    body_height="30"
                    class-line="!tw-my-0"
                  />
                </li>
              </template>

              <template v-else>
                <li class="item_det">
                  <LoadingSpinner
                    v-if="getDataLoading"
                    :show="true"
                    size="sm"
                  />
                  <img
                    v-else
                    :src="loadDetail?.product?.factory?.logo?.download_url"
                    width="24"
                    class="tw-ml-2"
                  />
                  <p class="tw-mb-0">{{ loadDetail?.product?.title }}</p>
                </li>
                <li class="item_det">
                  <p class="tw-mb-0">مشتری</p>
                  <div class="tw-w-1/2 tw-text-left">
                    <span
                      v-if="has_warehouse_transfer"
                      v-text="loadDetail?.load_type_title"
                    ></span>
                    <BaseAnimatedText
                      v-else
                      :text="get_fullname(loadDetail?.user) || ''"
                      max-length="full"
                    />
                  </div>
                </li>
                <li class="item_det">
                  <p class="tw-mb-0">شماره بارنامه</p>
                  {{ loadDetail ? $getNumberBar(loadDetail) : 'ندارد' }}
                </li>
                <li class="item_det">
                  <p class="tw-mb-0">کرایه هر تن</p>
                  <p class="tw-mb-0">
                    {{ toNumberFormat(loadDetail?.price_rent) }}
                    ریال
                  </p>
                </li>
                <li class="item_det" v-if="!has_warehouse_transfer">
                  <p class="tw-mb-0">واحد پولی</p>
                  {{ loadDetail?.type_arz_title }}
                </li>
                <li class="item_det" v-if="!has_warehouse_transfer">
                  <p class="tw-mb-0">فی فروش</p>
                  <template v-if="loadDetail?.type_arz !== '' && loadDetail?.type_arz !== 'rial'">
                    {{ parseFloat(loadDetail?.price_per_ton_arz) }}
                  </template>
                  <template>{{
                    toNumberFormat(loadDetail?.price_per_ton)
                  }}</template>
                  {{ loadDetail?.type_arz_title }}
                </li>
                <li v-if="!has_warehouse_transfer && loadDetail?.type_arz !== '' && loadDetail?.type_arz !== 'rial'"
                    class="item_det">
                  <p class="tw-mb-0">
                    نرخ
                    {{ loadDetail?.type_arz_title }}
                  </p>
                  <p class="tw-mb-0">
                    {{ toNumberFormat(loadDetail?.price_arz) }}
                    ریال
                  </p>
                </li>
                <li v-if="!has_warehouse_transfer && loadDetail?.type_arz !== '' && loadDetail?.type_arz !== 'rial'"
                    class="item_det">
                  <p class="tw-mb-0">فی فروش ریالی</p>
                  <p class="tw-mb-0">
                    {{
                      toNumberFormat(
                        (loadDetail?.price_per_ton_arz || 0) *
                          (loadDetail?.price_arz || 0),
                      )
                    }}
                    ریال
                  </p>
                </li>
                <li class="item_det">
                  <p class="tw-mb-0">جمع تناژ بارگیری</p>
                  <p class="tw-mb-0">
                    {{ sum_ton_loaded }}
                    تن
                  </p>
                </li>
                <li class="item_det">
                  <p class="tw-mb-0">حداکثر تناژ</p>
                  <p class="tw-mb-0">
                    {{ loadDetail?.max_ton_loaded }}
                    تن
                  </p>
                </li>
                <template v-if="has_warehouse_transfer">
                  <li class="item_det">
                    <p class="tw-mb-0">انبار مبدا</p>
                    <p class="tw-mb-0">
                      {{ loadDetail?.origin_warehouse.Nam }}
                    </p>
                  </li>
                  <li class="item_det">
                    <p class="tw-mb-0">انبار مقصد</p>
                    <p class="tw-mb-0">
                      {{ loadDetail?.destination_warehouse.Nam }}
                    </p>
                  </li>
                </template>
                <li class="item_det" v-else>
                  <p class="tw-mb-0">مبلغ فاکتور</p>
                  <p class="tw-mb-0">
                    <template v-if="loadDetail?.type_arz !== '' && loadDetail?.type_arz !== 'rial'">
                      {{ loadDetail?.price_per_ton_arz * sum_ton_loaded }}
                    </template>
                    <template>{{
                      toNumberFormat(
                        loadDetail?.price_per_ton * loadDetail?.max_ton_loaded,
                      )
                    }}</template>
                    {{ loadDetail?.type_arz_title }}
                  </p>
                </li>
                <li class="tw-mb-0 tw-mt-4">
                  <LicensePlate :car="loadDetail?.car" size="sm" />
                </li>
              </template>
            </ul>
          </div>
        </div>

        <!--    Left Side    -->
        <div class="tw-h-full tw-grid tw-grid-rows-[88px_40px_auto]">
          <div class="tw-grid tw-grid-cols-[220px_auto]">
            <div
              class="tw-border-l-0 tw-border-blue-dark-50 tw-p-6"
              :class="['md:tw-border-l md:!tw-pl-5']"
            >
              <base-date-picker
                title="تعیین تاریخ بارگیری"
                v-model="date_loaded"
                @change="(x) => x && focusOnReferred()"
              />
            </div>
            <div
              class="tw-flex tw-gap-5 tw-p-6"
              ref="inputs_card"
              :class="['md:!tw-pr-5']"
            >
              <div class="tw-flex tw-flex-1">
                <input-ayandeh
                  icon-on-input="barcode"
                  ref="input_referred"
                  float-label="شماره حواله"
                  placeholder="شماره حواله"
                  body-class="tw-w-1/2"
                  class="tw-border-l-0 tw-rounded-l-none"
                  :disabled="editing_referred"
                  @change="() => (received_referred_data = false)"
                  @keyupEnter="handleEnterReferredInput()"
                  @blur="handleEnterReferredInput()"
                  v-model:value="referred_code"
                />

                <input-ayandeh
                  icon-on-input="weight"
                  ref="input_tonage"
                  float-label="تناژ بار شده"
                  placeholder="تناژ"
                  body-class="tw-w-1/2"
                  class="tw-rounded-r-none"
                  @change="() => (received_referred_data = false)"
                  @keyupEnter="
                    () => !disabled_adding && handleEnterOnTonageInput()
                  "
                  v-model:value="tonage"
                />
              </div>
              <base-select
                v-if="!has_warehouse_transfer"
                class="tw-flex-1 md:tw-max-w-[250px]"
                title="انتخاب مبدا"
                placeholder="انتخاب مبدا"
                :float-title="true"
                :disabled-options="disabled_warehouse_item"
                :loading="loadingGetWarehouses"
                v-model="origin_warehouse_id"
                :options="warehouses"
                icon="warehouse"
              />
              <!--    Add Btn   -->
              <div class="tw-flex tw-gap-3 tw-flex-shrink-0">
                <NewBtn
                  v-if="editing_referred"
                  color="danger"
                  class="tw-w-10 !tw-p-0 tw-text-red"
                  icon="close"
                  icon-class="tw-text-red-200"
                  @click="cancel_edit_referred()"
                >
                </NewBtn>
                <NewBtn
                  color="primary"
                  class="tw-w-10 !tw-p-0"
                  @click="add_referred"
                  :disabled="disabled_adding"
                >
                  <template #default>
                    <BaseIcon
                      v-if="editing_referred"
                      icon="save"
                      class="tw-align-middle"
                    />
                    <BaseIcon
                      v-else
                      icon="add-circle"
                      class="tw-align-middle"
                    />
                  </template>
                </NewBtn>
              </div>
            </div>
          </div>
          <div>
            <h3
              class="tw-text-sm tw-flex tw-gap-3 tw-bg-gray-100 tw-px-5 tw-py-2"
            >
              <BaseIcon icon="forklift" class="tw-align-middle" />
              اطلاعات بارگیری
              {{ editing_referred }}
            </h3>
          </div>
          <div
            class="tw-relative"
            :class="[!referreds_details.length && 'tw-flex tw-text-center']"
          >
            <div
              v-if="loadingGetReferredsDetail"
              class="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-flex tw-justify-around tw-items-center tw-bg-gray-800 tw-opacity-35 z-1"
            >
              <LoadingSpinner :show="true" color="white" class="" />
            </div>
            <template v-if="referreds_details.length">
              <NumberedBox
                v-for="(kala, index) in referreds_details"
                :key="index"
                :number="index + 1"
                class="tw-p-5"
              >
                <p class="tw-mb-0 tw-text-blue-dark-200">
                  نام کالا در حسابداری
                </p>
                <div class="tw-flex tw-gap-3">
                  <BaseIcon icon="linked-services" class="tw-align-middle" />
                  <p class="tw-mb-0 tw-text-base" v-text="kala.kala_title"></p>
                </div>
                <GradientCard color="gray">
                  موجودی کالا
                  {{ kala.kala_remaining_inventory || 0 }}
                  تن / درصد بازاریابی
                  {{ kala.marketing_commission || 0 }}
                </GradientCard>
                <GradientCard
                  color="light_green"
                  v-for="(referred, ref_index) in kala.referreds"
                >
                  <div class="tw-flex tw-justify-between">
                    <div>
                      <BaseIcon
                        icon="barcode-scanner"
                        class="tw-align-middle tw-ml-2"
                      />
                      حواله متصل
                      {{ referred.referred_code }}
                    </div>
                    <div>
                      <BaseIcon
                        icon="qr-code"
                        class="tw-align-middle tw-ml-2"
                      />
                      <span class="tw-inline-block">
                        {{ referred.remaining_inventory }}
                        تن موجودی حواله
                      </span>
                    </div>
                    <div v-if="referred.warehouse_title">
                      <BaseIcon
                        icon="warehouse"
                        class="tw-align-middle tw-ml-2"
                      />
                      <span class="tw-inline-block">
                        {{ referred.warehouse_title }}
                      </span>
                    </div>
                    <div>
                      <template v-if="referred.tonage">
                        <BaseIcon
                          icon="weight"
                          class="tw-align-middle tw-ml-2"
                        />
                        <span class="tw-inline-block">
                          {{ referred.tonage }}
                          تن بارگیری شده
                        </span>
                      </template>
                    </div>
                    <div class="tw-text-left">
                      <template v-if="referred.status === 'added'">
                        <BaseIcon
                          icon="edit-note"
                          @click="
                            () =>
                              editing_referred !== referred.id &&
                              edit_referred(referred.id)
                          "
                          :class="
                            editing_referred === referred.id &&
                            '!tw-cursor-default !tw-text-primary-200'
                          "
                          class="tw-align-middle tw-text-primary-500 tw-cursor-pointer"
                        />
                        <BaseIcon
                          icon="donot-disturb"
                          @click="delete_referred(referred.id)"
                          class="tw-align-middle tw-text-red-500 tw-ml-2 tw-cursor-pointer"
                        />
                      </template>
                    </div>
                  </div>
                </GradientCard>
              </NumberedBox>
            </template>
            <div v-else class="tw-inline-block tw-m-auto">
              <BaseIcon
                icon="campaign"
                size="48"
                class="tw-mb-2 tw-text-gray-500"
              />
              <p>ابتدا تاریخ بارگیری، شماره حواله و تناژ را وارد کنید</p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div
        class="tw-flex max-md:tw-flex-col tw-gap-y-4 tw-justify-between tw-w-full"
      >
        <div class="tw-flex tw-items-center tw-gap-2 tw-text-blue-dark-500">
          <template v-if="!has_warehouse_transfer">
            <Checkbox
              v-model="taxCalculation"
              :by-conform="active_confirm_checkbox"
              disable-confirm-title="غیر فعال سازی ارزش افزوده"
              disable-confirm-text="درصورت غیر فعال بودن ارزش افزوده مبلغ ارزش افزوده در فاکتور لحاظ نخواهد شد."
              enable-confirm-title="فعال سازی ارزش افزوده"
              enable-confirm-text="در صورت فعال بودن ارزش افزوده مبلغ ارزش افزوده در فاکتور لحاظ می شود"
              class="tw-align-middle"
            />
            <label
              class="tw-mb-0 tw-cursor-pointer"
              for="print"
              @click="taxCalculation = !taxCalculation"
              >احتساب مالیات ارزش افزوده روی فاکتور
            </label>
          </template>
        </div>

        <div class="max-[395px]:tw-w-full tw-text-left tw-flex tw-gap-6">
          <NewBtn color="primary" icon="arrow-forward" @click="close"
            >بازگشت</NewBtn
          >
          <NewBtn
            color="primary"
            icon="add-circle"
            @click="do_loading()"
            :loading="loadingSetFinalLoading"
            :disabled="disabled_submit"
            >ثبت بارگیری</NewBtn
          >
        </div>
      </div>
    </template>
  </VerticalModal>

  <AdvancedEditLoadModal v-model="openEditLoadModal" :load-data="loadDetail" />
</template>

<script setup>
import {
  ref,
  defineEmits,
  defineProps,
  watch,
  computed,
  onMounted,
  nextTick,
  getCurrentInstance,
} from 'vue'
import NewBtn from '@/components/base/btn/NewBtn.vue'
import VerticalModal from '@/components/base/VerticalModal.vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import BaseAnimatedText from '@/components/base/BaseAnimatedText.vue'
import Plate from '@/components/partial/Plate.vue'
import LicensePlate from '@/components/partial/LicensePlate.vue'
import Checkbox from '@/components/base/input/Checkbox.vue'
import BaseDatePicker from '@/components/base/select/BaseDatePicker.vue'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import NumberedBox from '@/components/base/NumberedBox.vue'
import GradientCard from '@/components/base/GradientCard.vue'
import {
  apiGetReferredDetails,
  apiGetLoad,
  apiGetWarehouses,
  apiSetFinalLoading,
} from '@/services/loads/LoadingService'
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'
import ShineLoading from '@/components/loading/ShineLoading.vue'
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import AdvancedEditLoadModal from './AdvancedEditLoadModal.vue'

const props = defineProps({
  visible: { type: Boolean, default: false },
  load_id: { type: [String, Number], default: null },
  load: { type: Object, default: null },
})

const emit = defineEmits(['update:visible', 'updateLoadList', 'closed'])
const proxy = getCurrentInstance().proxy

const taxCalculation = ref(false)
const active_confirm_checkbox = ref(true)
const date_loaded = ref(null)
const referred_code = ref(null)
const inserted_referreds = ref([])
const tonage = ref(null)
const loadingGetReferredsDetail = ref(false)
const referreds_details = ref([])
const loadDetail = ref(null)
const getDataLoading = ref(false)
const confirmedListRefDetail = ref([])
const editing_referred = ref(null)
const received_referred_data = ref(false)
const warehouses = ref([])
const loadingGetWarehouses = ref(false)
const origin_warehouse_id = ref(null)
const duplicate_referreds = ref([])
const referred_id = ref(0)
const confirm_overweight = ref(0)
const loadingSetFinalLoading = ref(false)
const openEditLoadModal = ref(false)

const inputs_card = ref(null) // Input Card
const input_referred = ref(null) // Input Referred
const input_tonage = ref(null) // Input Tonage

const close = () => {
  emit('update:visible', false)
  emit('closed')
  resetModal()
}

const getNewReferredId = () => {
  referred_id.value++
  return referred_id.value
}

const resetModal = async () => {
  date_loaded.value = null
  referred_code.value = null
  tonage.value = null
  inserted_referreds.value = []
  referreds_details.value = []
  loadDetail.value = null
  confirmedListRefDetail.value = []
  loadingGetReferredsDetail.value = false
  editing_referred.value = null
  origin_warehouse_id.value = null
  confirm_overweight.value = 0
  active_confirm_checkbox.value = false
  taxCalculation.value = false
}
const disabled_adding = computed(() => {
  return (
    !!!date_loaded.value ||
    !!!referred_code.value ||
    !!!tonage.value ||
    (!has_warehouse_transfer.value ? !!!origin_warehouse_id.value : false) ||
    loadingGetReferredsDetail.value
  )
})

const disabled_submit = computed(() => {
  return (
    loadingSetFinalLoading.value ||
    !!!date_loaded.value ||
    editing_referred.value ||
    loadingGetReferredsDetail.value ||
    (!!referred_code.value &&
      (!!!tonage.value ||
        (!has_warehouse_transfer.value
          ? !!!origin_warehouse_id.value
          : false))) ||
    (!!!referred_code.value &&
      !!!tonage.value &&
      (!has_warehouse_transfer.value ? !!origin_warehouse_id.value : false) &&
      referreds_details.value.length === 0)
  )
})

onMounted(() => {})

const has_warehouse_transfer = computed(() => {
  if (loadDetail.value?.load_type === 'warehouse_transfer') return true
  return false
})

const sum_ton_loaded = computed(() => {
  return all_inserted_referreds.value.reduce(
    (total, item) => total + parseFloat(item.tonage || 0),
    0,
  )
})

const cancel_edit_referred = () => {
  editing_referred.value = null
  referred_code.value = null
  tonage.value = null
  origin_warehouse_id.value = null
}

const add_referred = async () => {
  if (editing_referred.value) {
    // عملیات ذخیره حواله ویرایش شده
    do_update_referred()
  } else {
    // عملیات افزودن حواله جدید

    inserted_referreds.value.push({
      id: getNewReferredId(),
      code: referred_code.value,
      tonage: tonage.value,
      warehouse_id: origin_warehouse_id.value?.toString() ?? null,
      status: 'added',
    })

    referred_code.value = tonage.value = origin_warehouse_id.value = null

    get_referreds_detail('tonage')

    await nextTick()
    input_referred.value.$refs.input?.focus()
  }
}

const current_referred = computed(() => {
  if (editing_referred.value) {
    return null
  } else {
    return {
      id: 10000,
      code: referred_code.value,
      tonage: tonage.value ?? '',
      warehouse_id: origin_warehouse_id.value ?? '',
      status: 'current',
    }
  }
})

const all_inserted_referreds = computed(() => {
  let rows = [...inserted_referreds.value]
  if (referred_code.value && current_referred.value) {
    rows.push(current_referred.value)
  }

  return rows
})

const get_referreds_detail = async (event_base = null) => {
  if (event_base !== 'remove') {
    if (
      (!date_loaded.value && !!!referred_code.value) ||
      getDataLoading.value ||
      loadingGetReferredsDetail.value ||
      received_referred_data.value
    )
      return false
  }

  if (
    !editing_referred.value &&
    inserted_referreds.value.filter((x) => x.code === referred_code.value)
      .length &&
    duplicate_referreds.value.indexOf(referred_code.value) === -1
  ) {
    proxy.$showConfirm(
      {
        title: 'حواله تکراری',
        confirm_text: 'بله ثبت شود',
        confirm_icon: 'check-circle',
        text:
          'شما حواله ' +
          referred_code.value +
          ' را قبلا وارد کرده اید. آیا می خواهید دوباره این حواله را ثبت کنید؟',
        icon: 'warning',
      },
      () => {
        duplicate_referreds.value.push(referred_code.value)
        get_referreds_detail(event_base)
      },
    )
    return
  }

  // وقتی همه حواله ها حذف شده اند وقتی دارد رفرش میشود، اطلاعات خالی شود
  if (!all_inserted_referreds.value.length) {
    referreds_details.value = []
    return
  }

  loadingGetReferredsDetail.value = true
  let body = {
    product_id: loadDetail.value?.product_id,
    referreds: all_inserted_referreds.value,
    confirmed: confirmedListRefDetail.value,
  }
  try {
    const response = await apiGetReferredDetails(body)
    if (!response) return

    if (response.status === 202 && response.data?.confirm_type) {
      proxy.$showConfirm(
        {
          title: 'برسی حواله',
          confirm_text: 'ادامه',
          confirm_icon: 'check-circle',
          text: response.data.message,
          icon: 'question',
        },
        () => {
          confirmedListRefDetail.value.push(response.data?.confirm_type)
          get_referreds_detail(event_base)
        },
      )
      return
    }

    referreds_details.value = response.data?.data || []
    received_referred_data.value = true

    if (event_base === 'referred') focusOnTonage()
  } catch (e) {
    remove_referred_detail_currently()
    // if (event_base === 'tonage') focusOnTonage()
    // if (event_base === 'referred') focusOnReferred()

    throw e
  } finally {
    loadingGetReferredsDetail.value = false
  }
}

// حذف حواله ایی که اطلاعاتش از بک اند برگشته اما الان دیگر در فرانت وجود ندارد
const remove_referred_detail_currently = () => {
  let current_referreds = all_inserted_referreds.value.map((x) => x.code)

  referreds_details.value.forEach(function (kala, k_index) {
    kala.referreds.forEach(function (referred, r_index) {
      if (!current_referreds.includes(referred.referred_code)) {
        kala.referreds.splice(r_index, 1)
      }
    })

    if (kala.referreds.length === 0) {
      referreds_details.value.splice(k_index, 1)
    }
  })
}

const focusOnReferred = async () => {
  await nextTick()
  input_referred.value.$refs.input?.focus()
}

const focusOnTonage = async () => {
  await nextTick()
  input_tonage.value.$refs.input?.focus()
}

const getLoad = async () => {
  if (!props.load_id) return false
  getDataLoading.value = true

  try {
    const response = await apiGetLoad(props.load_id)
    if (!response) return

    loadDetail.value = response.data?.load || null
    if (!has_warehouse_transfer.value) {
      if (!warehouses.value.length) getWarehouses()
      origin_warehouse_id.value = loadDetail.value?.origin_warehouse_id || null
    }
  } finally {
    getDataLoading.value = false
  }
}

const edit_referred = (id) => {
  editing_referred.value = id

  let find = inserted_referreds.value.find((x) => x.id === id)

  referred_code.value = find.code
  tonage.value = find.tonage
  origin_warehouse_id.value = find.warehouse_id
  scrollToTonage()
  focusOnTonage()
}

const delete_referred = (id) => {
  let index = inserted_referreds.value.findIndex((x) => x.id === id)
  inserted_referreds.value.splice(index, 1)
  get_referreds_detail('remove')
}

const handleEnterReferredInput = async () => {
  // focusOnTonage()
  get_referreds_detail('referred')
}

const do_update_referred = async () => {
  let find = inserted_referreds.value.find(
    (x) => x.id === editing_referred.value,
  )
  if (find) {
    find.tonage = tonage.value
    find.warehouse_id = origin_warehouse_id.value
    try {
      await get_referreds_detail('tonage')

      cancel_edit_referred()
    } catch (e) {
      focusOnTonage()
    }
  }

  editing_referred.value = referred_code.value = tonage.value = null
}
const handleEnterOnTonageInput = () => {
  if (editing_referred.value) {
    do_update_referred()
  } else {
    do_loading()
  }
}

const scrollToTonage = async () => {
  await nextTick()
  const el = inputs_card.value
  if (!el) return

  el.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}

const do_loading = async () => {
  if (
    sum_ton_loaded.value > loadDetail.value?.max_ton_loaded &&
    sum_ton_loaded.value !== confirm_overweight.value
  ) {
    proxy.$showConfirm(
      {
        title: 'تایید تناژ',
        confirm_text: 'ادامه',
        confirm_icon: 'check-circle',
        text:
          'تناژ وارد شده ' +
          sum_ton_loaded.value +
          ' تن و بیشتر از حداکثر تناژ ' +
          loadDetail.value?.max_ton_loaded +
          ' تن هست.<br>از ادامه عملیات اطمینان دارید؟ ',
        icon: 'warning',
      },
      () => {
        confirm_overweight.value = sum_ton_loaded.value
        do_loading()
      },
    )
    return
  }

  loadingSetFinalLoading.value = true
  let body = {
    load_id: loadDetail.value?.id,
    date_loaded: date_loaded.value,
    referreds: all_inserted_referreds.value,
    tax_calculation: taxCalculation.value,
    confirmed: confirmedListRefDetail.value,
  }

  try {
    let response = await apiSetFinalLoading(body)
    if (!response) return

    proxy.$my_alert(response.data.message, 'success')
    emit('updateLoadList', response.data.load_list_template)
    close()
  } finally {
    loadingSetFinalLoading.value = false
  }
}

const getWarehouses = async () => {
  loadingGetWarehouses.value = true
  try {
    const response = await apiGetWarehouses({ min_data: true })
    if (!response) return

    warehouses.value = response.data?.data
  } finally {
    loadingGetWarehouses.value = false
  }
}

// برای غیر فعال کردن انبارهایی که حواله های آن انبارها در حال حاضر اضافه شده اند
const disabled_warehouse_item = computed(() => {
  return inserted_referreds.value
    .filter((x) => x.code === referred_code.value)
    .map((x) => x.warehouse_id.toString())
})

watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      active_confirm_checkbox.value = true

      if (!loadDetail.value) {
        if (props.load_id) {
          getLoad()
        } else if (props.load) {
          loadDetail.value = props.load
        }
      }
    }
  },
)
</script>

<style scoped>
ul li.item_det {
  @apply tw-flex tw-justify-between tw-px-[10px] tw-py-[2px] tw-min-h-6 tw-mb-2;
}

ul li.item_det:nth-child(odd) {
  @apply tw-bg-gray-100 tw-rounded-[6px];
}
</style>
